'use client';

import { trackingLogService } from '@/features/tracking-log/trackingLogService';
import type {
  NaverGeocodeResponse,
  NaverLatLng,
  NaverMap,
} from '@/features/warehouses/types/map';
import { trackEvent } from '@/shared/utils/mixpanel';
import { useEffect, useRef } from 'react';
import WarehouseTable from './WarehouseTable';

interface Warehouse {
  name: string;
  phone: string;
  fax: string;
  address: string;
  region: string;
}

interface LocationMapProps {
  locations: Record<string, string>;
}

const warehouseData: Warehouse[] = [
  // Gwangju warehouses
  { name: '경인냉장', phone: '031-764-4116', fax: '031-764-4119', address: '경기도 광주시 경충대로 1502 (쌍령동)', region: '경기도 광주' },
  { name: '대재냉장', phone: '031-768-7600', fax: '031-768-7660', address: '경기도 광주시 초월읍 두둘기길 33', region: '경기도 광주' },
  { name: '대청냉장', phone: '031-761-3002', fax: '031-762-3002', address: '경기도 광주시 초월읍 산수로 370 (신월리)', region: '경기도 광주' },
  { name: '미빙냉장', phone: '031-762-0801', fax: '031-764-0575', address: '경기도 광주시 장지9길 74 (장지동)', region: '경기도 광주' },
  { name: '삼일냉장', phone: '031-769-3113', fax: '031-769-3121', address: '경기도 광주시 곤지암읍 경충대로311번길 17 (수양리)', region: '경기도 광주' },
  { name: '삼진1냉장', phone: '031-763-6661', fax: '031-769-6647', address: '경기도 광주시 경충대로 1801 (장지동)', region: '경기도 광주' },
  { name: '삼진2냉장', phone: '031-763-6662', fax: '070-4651-2060', address: '경기도 광주시 장지9길 64 (장지동)', region: '경기도 광주' },
  { name: '새영기업(우일)', phone: '031-768-2768', fax: '031-768-3768', address: '경기도 광주시 경충대로 2210 (삼동)', region: '경기도 광주' },
  { name: '서울물류', phone: '031-765-1546', fax: '031-765-1412', address: '경기도 광주시 경충대로 1425 (쌍령동)', region: '경기도 광주' },
  { name: '세원CS', phone: '031-765-5501', fax: '031-765-5505', address: '경기도 광주시 초월읍 경충대로 1146 (쌍동리)', region: '경기도 광주' },
  { name: '신우냉장', phone: '031-764-8107', fax: '031-764-2136', address: '경기도 광주시 도척면 국사봉로 75 (진우리)', region: '경기도 광주' },
  { name: '오아시스(견우푸드)', phone: '031-769-2944', fax: '031-769-2947', address: '경기도 광주시 곤지암읍 경충대로498번길 131', region: '경기도 광주' },
  { name: '한솔냉장', phone: '031-769-7971', fax: '031-769-7950', address: '경기도 광주시 장지9길 34-16 (장지동)', region: '경기도 광주' },
  { name: '효성냉장', phone: '031-763-3611', fax: '031-763-3615', address: '경기도 광주시 순암로 536-7 (삼동)', region: '경기도 광주' },
  { name: 'HL곤지암', phone: '031-8027-4717', fax: '031-798-7805', address: '경기도 광주시 도척면 도척로 401-98 (진우리)', region: '경기도 광주' },
  { name: 'SWC', phone: '031-766-8323', fax: '031-766-8326', address: '경기도 광주시 도척면 국사봉로 97-27 (진우리)', region: '경기도 광주' },

  // Yongin warehouses
  { name: '강동1냉장', phone: '031-286-2841', fax: '0507-337-2845', address: '경기도 용인시 기흥구 동탄기흥로 776', region: '경기도 용인' },
  { name: '강동2냉장', phone: '031-275-6811', fax: '0507-337-6879', address: '경기도 용인시 기흥구 농서로 51 (농서동)', region: '경기도 용인' },
  { name: '고려냉장', phone: '031-281-6511', fax: '031-281-6516', address: '경기도 용인시 기흥구 덕영대로 1994 (상갈동)', region: '경기도 용인' },
  { name: '남사물류', phone: '031-321-6668', fax: '031-321-6669', address: '경기도 용인시 처인구 남사읍 처인성로 1027 (완장리)', region: '경기도 용인' },
  { name: '동경냉동', phone: '031-323-7201', fax: '031-323-7202', address: '경기도 용인시 처인구 포곡읍 성산로 600 (전대리)', region: '경기도 용인' },
  { name: '베이지박스투(요진TF)', phone: '031-286-8260~1', fax: '070-8677-2468', address: '경기도 용인시 기흥구 고매로43번길 1 (공세동)', region: '경기도 용인' },
  { name: '세미냉장(이스트벨리)', phone: '031-286-6307', fax: '031-286-0279', address: '경기도 용인시 기흥구 동탄기흥로681번길 1(고매동)', region: '경기도 용인' },
  { name: '연세(세종)냉장', phone: '031-283-9245', fax: '031-274-8314', address: '경기도 용인시 기흥구 기곡로 22 (하갈동)', region: '경기도 용인' },
  { name: '아워홈', phone: '031-526-6546', fax: '031-526-6557', address: '경기도 용인시 처인구 남사읍 당하로 154 (북리)', region: '경기도 용인' },
  { name: '아이린(양지선일)', phone: '031-337-2017', fax: '031-337-2019', address: '경기도 용인시 처인구 양지면 중부대로 2605 (추계리)', region: '경기도 용인' },
  { name: '에이스기흥', phone: '031-284-7054', fax: '0507-337-7057', address: '경기도 용인시 기흥구 원고매로 29 (고매동)', region: '경기도 용인' },
  { name: '에이스용인', phone: '031-282-6161', fax: '0507-337-6160', address: '경기도 용인시 기흥구 중부대로 714 (상하동)', region: '경기도 용인' },
  { name: '에이스처인', phone: '031-338-8454', fax: '0507-337-0144', address: '경기도 용인시 처인구 중부대로 1022-1 (삼가동)', region: '경기도 용인' },
  { name: '오로라CS', phone: '031-281-7445', fax: '031-281-9725', address: '경기도 용인시 기흥구 중부대로684번길 14 (상하동)', region: '경기도 용인' },
  { name: '유상', phone: '031-286-4001', fax: '031-286-4007', address: '경기도 용인시 기흥구 동탄기흥로 741 (고매동)', region: '경기도 용인' },
  { name: '프라자', phone: '031-8097-7000', fax: '0507-337-7007', address: '경기도 용인시 처인구 남사읍 경기동로 55 (북리)', region: '경기도 용인' },
  { name: '희창', phone: '031-339-0271', fax: '031-332-0125', address: '경기도 용인시 처인구 모현읍 포은대로 892 (오산리)', region: '경기도 용인' },
  { name: 'CH', phone: '031-281-3200', fax: '0507-337-1051', address: '경기도 용인시 기흥구 하갈로 141-17 (상갈동)', region: '경기도 용인' },

  // Other region warehouses
  { name: '그레이박스', phone: '031-8000-9777', fax: '031-285-5777', address: '경기도 안산시 단원구 해봉로 232 (성곡동, GREYBOX안산물류센터)', region: '기타지역' },
  { name: '글로벌냉동1물류', phone: '032-327-1981', fax: '032-327-1983', address: '경기도 안성시 보개면 남사당로 71 (불현리)', region: '기타지역' },
  { name: '글로벌냉동2물류', phone: '032-3327-1981', fax: '032-327-1983', address: '경기도 안성시 보개면 너리굴길 16', region: '기타지역' },
  { name: '다이아몬드냉장', phone: '031-733-2155', fax: '031-746-4939', address: '경기도 성남시 중원구 둔촌대로456번길 7 (상대원동)', region: '기타지역' },
  { name: '더본냉장', phone: '031-377-2937', fax: '031-374-7318', address: '경기도 오산시 동부대로 468-31 (원동)', region: '기타지역' },
  { name: '도지냉장', phone: '031-632-2235', fax: '', address: '이천시 백사면 청백리로 287', region: '기타지역' },
  { name: '동원이천', phone: '031-635-6010', fax: '031-635-6090', address: '경기도 이천시 호법면 중부대로763번길 141-27 (안평리)', region: '기타지역' },
  { name: '동일냉장', phone: '031-638-5200', fax: '031-638-8284', address: '경기도 이천시 신둔면 경충대로 3035 (수남리)', region: '기타지역' },
  { name: '로얄냉장', phone: '031-713-4121', fax: '031-713-5474', address: '경기도 성남시 분당구 대왕판교로 95 (금곡동)', region: '기타지역' },
  { name: '롯데물류', phone: '031-633-9700', fax: '031-633-9774', address: '경기도 이천시 마장면 이장로311번길 91 (장암리)', region: '기타지역' },
  { name: '사조냉장', phone: '02-866-0101', fax: '02-863-2512', address: '서울 금천구 두산로7길 13', region: '기타지역' },
  { name: '신영(여주)', phone: '031-881-2167', fax: '031-881-2191', address: '경기도 여주시 삼교1길 9-7 (삼교동)', region: '기타지역' },
  { name: '인천로지스틱스', phone: '032-886-6400', fax: '032-881-8787', address: '인천광역시 중구 축항대로117번길 21 (항동7가)', region: '기타지역' },
  { name: '일죽(냉동)냉동', phone: '070-8656-9620', fax: '070-4325-0066', address: '경기도 안성시 일죽면 사실로 161-41 (방초리)', region: '기타지역' },
  { name: '일죽(냉장)냉동', phone: '031-675-9600', fax: '031-675-0066', address: '경기도 안성시 일죽면 사실로 161-41 (방초리)', region: '기타지역' },
  { name: '정양냉장', phone: '031-634-7172', fax: '031-634-7173', address: '경기도 이천시 마장면 둔터로 24-26 (장암리)', region: '기타지역' },
  { name: '삼영(수원한솔)', phone: '031-278-7350', fax: '031-278-7351', address: '경기도 수원시 권선구 오목천로132번길 55 (고색동)', region: '기타지역' },
  { name: 'HL동탄', phone: '031-378-5728', fax: '0507-337-5728', address: '경기도 화성시 동탄물류로 103 (신동)', region: '기타지역' },

  // Busan warehouses
  { name: '고려물류(부산)', phone: '051-261-6161', fax: '051-261-6165', address: '부산광역시 사하구 다대로 332 (장림동)', region: '부산' },
  { name: '삼일냉장(부산)', phone: '051-262-3101', fax: '051-262-3104', address: '부산광역시 사하구 서포로 36 (구평동)', region: '부산' },
  { name: '삼진냉장(부산)', phone: '051-204-5501', fax: '051-205-1331', address: '부산광역시 사하구 장평로 269 (신평동)', region: '부산' },
  { name: '한일냉장1(부산)', phone: '051-294-1818', fax: '051-294-1819', address: '부산광역시 사하구 원양로 319 (감천동)', region: '부산' },
  { name: '한일냉장2(부산)', phone: '051-203-4020', fax: '051-294-1815', address: '부산광역시 사하구 원양로 314 (감천동)', region: '부산' },
];

export default function LocationMap({ locations }: LocationMapProps) {
  const mapRef = useRef<HTMLDivElement | null>(null);

  const convertAddressesToCoordinates = (
    addresses: Record<string, string>,
    map: NaverMap,
    CustomOverlay: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  ) => {
    if (!window.naver) return;

    Object.entries(addresses).forEach(([name, address]) => {
      window.naver.maps.Service.geocode(
        { query: address },
        (status: string, response: NaverGeocodeResponse) => {
          if (status !== window.naver.maps.Service.Status.OK) {
            return;
          }

          if (response.v2.addresses.length === 0) {
            return;
          }

          const result = response.v2.addresses[0];
          if (!result) {
            return;
          }

          const lat = parseFloat(result.y);
          const lng = parseFloat(result.x);
          const position = new window.naver.maps.LatLng(lat, lng);
          const overlay = new CustomOverlay(position, name);
          overlay.setMap(map);

          new window.naver.maps.Marker({
            position,
            map,
            title: name,
          });
        },
      );
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const initializeMap = (CustomOverlay: any) => {
    if (!window.naver || !mapRef.current) return;

    const map = new window.naver.maps.Map(mapRef.current, {
      center: new window.naver.maps.LatLng(37.3505, 127.198),
      zoom: 10,
      zoomControl: true,
      zoomControlOptions: {
        position: window.naver.maps.Position.TOP_RIGHT
      }
    });

    convertAddressesToCoordinates(locations, map, CustomOverlay);
  };

  useEffect(() => {
    trackingLogService.saveUtmParams();
    trackEvent('Page View', { 'Page Name': '지도' });
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${process.env.NEXT_PUBLIC_NAVER_CLIENT_ID}&submodules=geocoder&callback=geocodeAddresses`;
    script.async = true;

    script.onload = () => {
      if (!window.naver) return;

      class CustomOverlay extends window.naver.maps.OverlayView {
        position: NaverLatLng;
        text: string;
        element: HTMLDivElement;

        constructor(position: NaverLatLng, text: string) {
          super();
          this.position = position;
          this.text = text;
          this.element = document.createElement('div');
          this.element.className = 'custom-overlay';
          this.element.innerHTML = `<div class="label">${text}</div>`;
          Object.assign(this.element.style, {
            position: 'absolute',
            background: 'white',
            padding: '5px 10px',
            borderRadius: '4px',
            boxShadow: '0px 2px 6px rgba(0,0,0,0.3)',
            fontSize: '14px',
            fontWeight: 'bold',
            textAlign: 'center',
            whiteSpace: 'nowrap',
          });
        }

        onAdd() {
          const overlayLayer = this.getPanes().overlayLayer;
          if (!overlayLayer) return;
          overlayLayer.appendChild(this.element);
        }

        draw() {
          const projection = this.getProjection();
          if (!projection) return;

          const position = projection.fromCoordToOffset(this.position);
          this.element.style.left = `${position.x - this.element.offsetWidth / 2}px`;
          this.element.style.top = `${position.y - 60}px`;
        }

        onRemove() {
          if (this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
          }
        }
      }

      setTimeout(() => initializeMap(CustomOverlay), 100);
    };

    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [locations]);

  return (
    <div className="w-full px-2 sm:px-4 md:px-6 lg:px-8 py-2 sm:py-4 md:py-6">
      <div className="bg-white rounded-lg shadow-md p-2 sm:p-4 w-full relative z-0">
        <div
          ref={mapRef}
          className="w-full rounded-lg overflow-hidden relative z-0"
          style={{
            width: '100%',
            height: 'min(60vh, 400px)',
            minHeight: '250px',
          }}
        />
        <WarehouseTable warehouses={warehouseData} />
      </div>
    </div>
  );
}
